import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import Constants from '../../../definitions/constants';
import LocaleTooling from '../../../tooling/localeTooling';

import Button from '../common/inputs/button';
import Select from '../common/inputs/select';
import FetchAutocompleteList from '../common/inputs/fetchAutocompleteList';
import BlueHeader from '../common/inputs/blueHeader';

const ExportFiltersSelectors = props => {
  const {
    onChangeFilter,
    groupsFilters,
    groupsProps,
    groupsFetchAction,
    calculationUnitsFilters,
    calculationUnitsProps,
    calculationUnitsFetchAction,
  } = props;
  
  let calculationUnitsLoading = calculationUnitsProps.loading;
  let calculationUnitsData = calculationUnitsProps.data;
  let groupsLoading = groupsProps.loading;
  let groupsData = groupsProps.data;
  return (
    <div className="export_configuration_filters_section">      
      <div className="export_configuration_filter groups_filter">
        <label className="export_configuration_filter_label top_row"><FormattedMessage id="exportConfigurationsAdmin.groupFiltersLabel"/></label>
        <Select 
          value={groupsFilters["groups_criteria"]}
          onChange={onChangeFilter}
          labelLocale={<FormattedMessage id="exportConfigurationsAdmin.criteriaSelectorLabel"/>}
          options={InterfaceTooling.getSelectArray("selectKeys.exportConfigurationsAdmin.groupsFilter", "exportConfigurationsAdmin.criteriaSelectorOptions", false)}
          data-path="groups_criteria"
        />
        {(groupsFilters["groups_criteria"]!="" && groupsFilters["groups_criteria"]!=Constants.selectKeys.exportConfigurationsAdmin.groupsFilter.ALL) && (
          <FetchAutocompleteList        
            values={groupsFilters["groups_selected"]}
            onChange={onChangeFilter}
            addSelectLocale={LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id:"exportConfigurationsAdmin.groupFilterFinderLabel"}))}
            options={InterfaceTooling.getSelectArrayFromArrayOfObjects(groupsData, "id", "name", false)}
            valueAccesor={"id"}
            labelAccesor={"name"}
            fetchListAction={groupsFetchAction}
            loadingFetch={groupsLoading}
            data-path="groups_selected"
          />
        )}
      </div>
      <div className="export_configuration_filter calculation_units_filter">
        <label className="export_configuration_filter_label top_row">{LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id: "exportConfigurationsAdmin.calculationUnitsFiltersLabel"}))}</label>
        <Select 
          value={calculationUnitsFilters["calculation_units_criteria"]}
          onChange={onChangeFilter}
          labelLocale={<FormattedMessage id="exportConfigurationsAdmin.criteriaSelectorLabel"/>}
          options={InterfaceTooling.getSelectArray("selectKeys.exportConfigurationsAdmin.calculationUnitsFilter", "exportConfigurationsAdmin.criteriaSelectorOptions", false)}
          data-path="calculation_units_criteria"
        />
        {(calculationUnitsFilters["calculation_units_criteria"]!="" && calculationUnitsFilters["calculation_units_criteria"]!=Constants.selectKeys.exportConfigurationsAdmin.calculationUnitsFilter.ALL) && (
          <FetchAutocompleteList        
            values={calculationUnitsFilters["calculation_units_selected"]}
            onChange={onChangeFilter}
            addSelectLocale={LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id:"exportConfigurationsAdmin.calculationUnitFilterFinderLabel"}))}
            options={InterfaceTooling.getSelectArrayFromArrayOfObjects(calculationUnitsData, "id", "name", false)}
            valueAccesor={"id"}
            labelAccesor={"name"}
            fetchListAction={calculationUnitsFetchAction}
            loadingFetch={calculationUnitsLoading}
            data-path="calculation_units_selected"
          />
        )}
      </div>      
    </div>
  );
};

export default ExportFiltersSelectors;



// WEBPACK FOOTER //
// ./source/client/components/exportConfigurationsAdmin/exportFiltersSelectors.jsx